import {gql} from '@apollo/client'

export const CREATE_POLICY_FILTER = gql`
  mutation createPolicyFilter($policyFilterData: policy_filter_input!) {
    createPolicyFilter(policyFilterData: $policyFilterData) {
      success
      errors {
        field
        message
      }
      policyFilter {
        id
        name
        scope
        filters
        updated
      }
    }
  }
`

export const UPDATE_POLICY_FILTER = gql`
  mutation updatePolicyFilter($id: Int!, $policyFilterData: policy_filter_update_input!) {
    updatePolicyFilter(id: $id, policyFilterData: $policyFilterData) {
      success
      errors {
        field
        message
      }
      policyFilter {
        id
        name
        scope
        filters
        updated
      }
    }
  }
`

export const DELETE_POLICY_FILTER = gql`
  mutation deletePolicyFilter($id: Int!) {
    deletePolicyFilter(id: $id) {
      success
      errors {
        field
        message
      }
    }
  }
`
